import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/Login/login.vue")
  },
  {
    path: "/",
    name: "home",
    component: () => import("@/views/Home/home.vue")
  },
  {
    path: "/register",
    name: "register",
    component: () => import("@/views/Apply/apply.vue")
  },
  {
    path: "/carousel",
    name: "carousel",
    component: () => import("@/views/Carousel/carousel.vue")
  },
  {
    path: "/introduce",
    name: "introduce",
    component: () => import("@/views/productIntroduce/introduce.vue")
  },
  {
    path: "*",
    redirect: "/"
  }
];

const router = new VueRouter({
  mode: "history",
  routes
});

export default router;
